(() => {
  'use strict';
  if (window.__ouccaMeasurement) return;
  window.__ouccaMeasurement = true;
  const node = document.getElementById('oucca-measurement-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (config.designMode && !config.debug) return;
  const pendingKey = 'oucca:pricing-attempt';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const layer = window.dataLayer = window.dataLayer || [];
  const command = function () { layer.push(arguments); };
  command('consent', 'default', {analytics_storage:'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
  const canonical = location.origin + location.pathname;
  const measurementUrl = new URL(canonical);
  const incomingUrl = new URL(location.href);
  for (const key of ['utm_source','utm_medium','utm_campaign','utm_term','utm_content']) {
    const value = incomingUrl.searchParams.get(key);
    if (value && value.length <= 200 && /^[a-zA-Z0-9 _./:+-]*$/.test(value)) measurementUrl.searchParams.set(key, value);
  }
  const measuredLocation = measurementUrl.href;
  let referrer = '';
  try { const url = new URL(document.referrer); referrer = url.origin + url.pathname; } catch (_) {}
  layer.push({page_location:measuredLocation,page_referrer:referrer,page_path:location.pathname});
  let started = false;
  let pageMeasured = false;
  let lastSubmit = 0;
  const readPending = () => { try { return JSON.parse(sessionStorage.getItem(pendingKey)); } catch (_) { return null; } };
  const clearPending = () => { try { sessionStorage.removeItem(pendingKey); } catch (_) {} };
  const emit = (event, values = {}) => {
    if (!allowed()) return;
    layer.push({event, oucca_event:true, page_location:measuredLocation, page_referrer:referrer, page_path:location.pathname,
      debug_mode:config.debug === true, ecommerce:null, form_id:undefined, submission_id:undefined,
      lead_type:undefined, contact_channel:undefined, interaction_type:undefined, ...values});
  };
  function initialise() {
    const permission = allowed();
    command('consent', 'update', {analytics_storage:permission ? 'granted' : 'denied',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
    if (!permission) { clearPending(); return; }
    if (/^GTM-[A-Z0-9]+$/.test(config.gtmId || '') && !window.__ouccaGtmLoaded) {
      window.__ouccaGtmLoaded = true;
      layer.push({'gtm.start':Date.now(),event:'gtm.js'});
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtm.js?id=' + config.gtmId;
      document.head.appendChild(script);
    }
    if (!pageMeasured) {
      pageMeasured = true;
      emit('page_view');
      if (config.product?.id && config.product?.name) emit('view_item', {
        ecommerce:{items:[{item_id:String(config.product.id),item_name:config.product.name,item_brand:'OUCCA Medical Systems'}]}
      });
    }
    const pending = readPending();
    if (document.querySelector('[data-oucca-pricing-success="true"]') && pending &&
        pending.path === location.pathname && Date.now() - pending.time >= 0 && Date.now() - pending.time < 1800000) {
      clearPending();
      emit('generate_lead', {form_id:'OUCCAQuote',submission_id:pending.id,lead_type:'equipment_pricing'});
    }
  }
  document.addEventListener('visitorConsentCollected', initialise);
  document.addEventListener('oucca:crm-success', event => {
    if (event.detail?.formId !== 'da68bd15-1bd8-4a7a-a68a-b95a04d7a144') return;
    const values = {form_id:event.detail.formId, submission_id:event.detail.submissionId, lead_type:'equipment_pricing'};
    emit('submit_get_pricing', values);
    emit('generate_lead', values);
  });
  if (window.Shopify?.customerPrivacy) initialise();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {if (!error) initialise();});
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.getAttribute('href'), location.href); } catch (_) { return; }
    if (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') emit('click_whatsapp', {contact_channel:'whatsapp'});
    else if (url.protocol === 'mailto:') emit('click_email', {contact_channel:'email'});
    else if (url.origin === location.origin && url.pathname === '/pages/compare-systems') emit('compare_systems', {interaction_type:'navigation'});
  });
  function markStarted(formId) {
    if (!started && allowed()) {
      started = true;
      emit('start_get_pricing', {form_id:formId});
    }
  }
  document.addEventListener('focusin', event => {
    if (event.target.closest?.('#OUCCAQuote')) markStarted('OUCCAQuote');
  });
  // Cross-origin forms do not expose their input events to the storefront.
  // Count focus entering this form's iframe, never the iframe loading.
  window.addEventListener('blur', () => {
    setTimeout(() => {
      const active = document.activeElement;
      if (active?.tagName === 'IFRAME' && active.closest?.('#oucca-crm-form')) {
        markStarted('da68bd15-1bd8-4a7a-a68a-b95a04d7a144');
      }
    }, 0);
  });
  document.addEventListener('submit', event => {
    if (event.target.id !== 'OUCCAQuote' || !allowed() || !event.target.checkValidity()) return;
    const now = Date.now();
    if (now - lastSubmit < 3000) return;
    lastSubmit = now;
    const id = window.crypto.randomUUID();
    try { sessionStorage.setItem(pendingKey, JSON.stringify({id,time:now,path:location.pathname})); } catch (_) {}
    emit('submit_get_pricing', {form_id:'OUCCAQuote',submission_id:id});
  }, true);
})();

